import { useState } from 'react';
import { fetchDownloadTaskIdPlus } from '../services';
import { notificationDownloadError } from '@intelligence/services/download';
import { getBasePath } from '@/utils/utils';

import type { IDateValue } from '@intelligence/types/common';
import type { IFilter, IPCConsoleGame } from '@intelligence/types/pcConsoleCompare';
import type { IComposedDateData } from '@intelligence/components/ComposedDatePicker/types';

export default function useDownload(option: {
  pageName: string;
  games: IPCConsoleGame[];
  devices?: string[];
  composedDateData: IComposedDateData;
  filter?: IFilter;
  downloadDateValue: IDateValue;
}) {
  const { pageName, games, devices, composedDateData, filter, downloadDateValue } = option;

  const [visible, setVisible] = useState(false);
  const [isDownloading, setIsDownLoading] = useState(false);

  const handleConfirm = async (payload: any): Promise<void> => {
    setIsDownLoading(true);
    try {
      const { task_id: taskId } = await fetchDownloadTaskIdPlus({
        pageName,
        games,
        devices,
        regionData: filter?.regionData,
        composedDateData,
        downloadDateValue,
        downloadConfig: payload,
      });
      // 缺失taskId throw异常，走catch
      if (!taskId) throw new Error('missing taskId when download.');
      const urlSearchParams = new URLSearchParams();
      urlSearchParams.set('entityType', encodeURIComponent('pc,console'));
      urlSearchParams.set('taskId', encodeURIComponent(taskId));
      window.open(encodeURI(`${getBasePath()}/intelligence/download?${urlSearchParams.toString()}`));
    } catch (exception: any) {
      notificationDownloadError({
        code: exception?.code,
        msg: exception?.message || 'unknow exception occured when download.',
      });
    } finally {
      setIsDownLoading(false);
    }
  };

  const handleCancel = () => { };

  const handleClose = () => {
    setVisible(false);
  };

  return {
    visible,
    setVisible,
    isDownloading,
    handleConfirm,
    handleCancel,
    handleClose,
  };
}
